// hooks/useAxiosInterceptor.ts
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import AuthContext from "../context/auth/AuthContext";
import { useUserContext } from "../context/auth/UserContext";
import { useNavigate } from "react-router-dom";

const useAxiosInterceptor = () => {
  const navigate = useNavigate();
  const [isInterceptorSet, setInterceptorSet] = useState(false);

  const authContext = useContext(AuthContext);
  const { token, logout } = authContext;

  const { setIsApploading, setIsLogoutClick, setShowLogoutDialog } =
    useUserContext();

  const handleLogout = (e?: any) => {
    if (e) e.preventDefault();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    axios.get("/logout", config).then((response) => {
      console.log("LOGGED OUT", response);
      if (logout) {
        logout();
        navigate("/");
      }
    });

    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userAccess");
    localStorage.removeItem("companyProfileID");
    localStorage.removeItem("companyLogo");

    setIsLogoutClick(true);
    setIsApploading(false);

    setShowLogoutDialog(true);
  };

  useEffect(() => {
    if (token) {
      // Create an interceptor when token is available
      const requestInterceptor = axios.interceptors.request.use(
        (config) => {
          if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
          }
          return config;
        },
        (error) => Promise.reject(error)
      );

      setInterceptorSet(true); // Interceptor is set, allow app rendering

      // Cleanup function to remove interceptor when component unmounts
      return () => {
        axios.interceptors.request.eject(requestInterceptor);
      };
    } else {
      setInterceptorSet(false); // No token, prevent rendering
    }
  }, [token]);

  // Add a response interceptor
  axios.interceptors.response.use(
    (response) => {
      return response; // Return data for further processing
    },
    (error) => {
      // Handle errors globally
      console.log("API Error:", error);
      console.error("API Error:", error);
      if (error.response.status === 401) {
        handleLogout();
      }
      return error;
    }
  );

  return isInterceptorSet;
};

export default useAxiosInterceptor;
